import React from "react";
import styled from "styled-components/macro";
import {
  RadioGroup,
  Radio,
  FormControl,
  FormControlLabel,
  Select,
  MenuItem,
  Input
} from "@material-ui/core";

import { LabelOptionTypes } from "../constants";

const PseudoStyles = `
  content: none;
  transition: none;
  border: 0;
`;

const InputFontStyles = `
  font-family: Roboto;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  color: #5F6368;
`;

const StyledWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledLabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1em;
  align-items: center;
`;

const StyledLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #102F54BF;
`;

const StyledRequiredText = styled.span`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #C40A0A;
`;

const StyledFormControlLabel = styled(FormControlLabel)`&& {
  && > span {
    font-size: 14px;
    color: #5F6368;
    font-weight: 400;
    line-height: 16px;
  }
  && > span > span {
    color: #005AA9;
  }
}`;

const StyledFormControl = styled(FormControl)`
  width: 100%;
`;

const StyledSelect = styled(Select)`
  font-weight: 400;
  border-radius: 8px 8px 0 0;
  height: 50px;
  background-color: #F0F0F0;
  div {
    padding: 8px;
    background: rgba(0, 0, 0, 0) !important;
  }
  && > div > div {
    ${InputFontStyles}
  }
`;

const StyledMenuItem = styled(MenuItem)`&&& {
  height: 36px;
}`;

const StyledInput = styled(Input)`&&& {
  border: 1px solid #DADCE0;
  border-radius: 8px;
  ::before {
    ${PseudoStyles}
  }
  ::after {
    ${PseudoStyles}
  }
  && > input {
    padding: 8px;
    margin: 8px;
    ${InputFontStyles}
    ::-webkit-input-placeholder {
      ${InputFontStyles}
    }
  }
}`;

const LabelOption = ({
  label,
  type,
  options = [],
  value,
  onChange: handleOnChange,
  showTypeRequired,
  showNameRequired
}) => {
  const determinePicker = () => {
    switch (type) {
      case LabelOptionTypes.RADIO:
        return (
          <RadioGroup
            row
            value={value}
            onChange={handleOnChange}
          >
            {
              options?.map(({ id, name }) => <StyledFormControlLabel
                key={id}
                control={<Radio />}
                label={name}
                value={id}
              />)
            }
          </RadioGroup>
        );
      case LabelOptionTypes.DROPDOWN:
        return (
          <StyledFormControl>
            <StyledSelect
              onChange={handleOnChange}
              value={value}
            >
              {options?.map(({ id, name }) => <StyledMenuItem key={id} value={id}>{name}</StyledMenuItem>)}
            </StyledSelect>
          </StyledFormControl>
        );
      default:
        return (
          <StyledInput
            variant="standard"
            name="blastName"
            onChange={handleOnChange}
            value={value}
          />
        );
    }
  };

  const determineRequiredLabel = () => (((type === LabelOptionTypes.INPUT && showNameRequired) || (type === LabelOptionTypes.DROPDOWN && showTypeRequired)) ?
    (<StyledRequiredText>Required</StyledRequiredText>) :
    null);

  return (
    <StyledWrapper>
      <StyledLabelWrapper>
        <StyledLabel>{label}</StyledLabel>
        {determineRequiredLabel()}
      </StyledLabelWrapper>
      {determinePicker()}
    </StyledWrapper>
  );
};

export default LabelOption;
